// Non-Consultant roles that act as client (company-side) users. Mirrors
// CLIENT_ROLES in backend/apps/core/permissions.py. These roles get the simple
// one-screen client dashboard instead of the dense consultant app.
export const CLIENT_ROLES = ['BEE Manager', 'HR', 'Logistics'];

export const isClientRole = (role) => CLIENT_ROLES.includes(role);
